export default __webpack_public_path__ + "static/media/hexofy-logo-rectangle.6dbd0fc6.svg";